// i18n namespace "team" (spec c.7 §5, founder + COO decisions 2026-10-09).
// Two principals only. Numbers are interpolated from src/content/team.ts:
// {{years}} = combined (renders 40), {{n}} = the principal's own years.
// Bios: prior firms as "while at / previously at"; their clients are programs delivered
// at those firms, never DuxTrans clients. No current-employer title, no sanctioned entities.

export const en = {
  label: "Team",
  title: "Senior people on every engagement",
  lead: "Two senior consultants, named and reachable.",
  yearsLine: "{{n}}+ years in SAP",
  modulesLabel: "SAP modules",
  industriesLabel: "Industries",
  raul: {
    name: "Raul Garcia Bonifaz",
    role: "SAP program director and business development",
    bio: "{{n}}+ years leading SAP implementations and business development in Mexico and Latin America. Previously a senior manager at KPMG and IBM, leading large SAP teams on programs for Heineken Mexico, British American Tobacco and Banco Ficohsa.",
    industries: "Manufacturing · Beverages · Banking · Pharma · Retail",
  },
  efren: {
    name: "Efrén Serrano",
    role: "Senior SAP logistics and supply chain consultant",
    bio: "{{n}}+ years in SAP logistics and advanced warehouse management. Delivery manager for multi-country S/4HANA EWM rollouts. While at Accenture, he delivered supply chain programs for PepsiCo LATAM, Panasonic Automotive, KION Group and Convatec.",
    industries: "Automotive · Pharma · Medical devices · Manufacturing · Consumer goods",
  },
};

export const es = {
  label: "Equipo",
  title: "Gente senior en cada proyecto",
  lead: "Dos consultores senior, con nombre y a quienes puedes escribir.",
  yearsLine: "{{n}}+ años en SAP",
  modulesLabel: "Módulos SAP",
  industriesLabel: "Industrias",
  raul: {
    name: "Raul Garcia Bonifaz",
    role: "Director de programas SAP y desarrollo de negocio",
    bio: "{{n}}+ años dirigiendo implementaciones SAP y desarrollo de negocio en México y Latinoamérica. Antes, senior manager en KPMG e IBM, al frente de grandes equipos SAP en programas para Heineken México, British American Tobacco y Banco Ficohsa.",
    industries: "Manufactura · Bebidas · Banca · Farmacéutica · Retail",
  },
  efren: {
    name: "Efrén Serrano",
    role: "Consultor senior SAP de logística y cadena de suministro",
    bio: "{{n}}+ años en logística SAP y gestión avanzada de almacenes. Delivery manager de implementaciones S/4HANA EWM en varios países. En Accenture entregó programas de cadena de suministro para PepsiCo LATAM, Panasonic Automotive, KION Group y Convatec.",
    industries: "Automotriz · Farmacéutica · Dispositivos médicos · Manufactura · Bienes de consumo",
  },
};

export const fr = {
  label: "Équipe",
  title: "Des seniors sur chaque mission",
  lead: "Deux consultants seniors, nommés et joignables.",
  yearsLine: "{{n}}+ ans sur SAP",
  modulesLabel: "Modules SAP",
  industriesLabel: "Secteurs",
  raul: {
    name: "Raul Garcia Bonifaz",
    role: "Directeur de programmes SAP et développement commercial",
    bio: "{{n}}+ ans à diriger des implémentations SAP et le développement commercial au Mexique et en Amérique latine. Auparavant senior manager chez KPMG et IBM, à la tête de grandes équipes SAP sur des programmes pour Heineken Mexico, British American Tobacco et Banco Ficohsa.",
    industries: "Industrie · Boissons · Banque · Pharma · Distribution",
  },
  efren: {
    name: "Efrén Serrano",
    role: "Consultant senior SAP logistique et chaîne d’approvisionnement",
    bio: "{{n}}+ ans en logistique SAP et gestion avancée des entrepôts. Delivery manager de déploiements S/4HANA EWM multi-pays. Chez Accenture, il a livré des programmes de chaîne d’approvisionnement pour PepsiCo LATAM, Panasonic Automotive, KION Group et Convatec.",
    industries: "Automobile · Pharma · Dispositifs médicaux · Industrie · Biens de consommation",
  },
};

export const pt = {
  label: "Equipe",
  title: "Profissionais sêniores em cada projeto",
  lead: "Dois consultores sênior, com nome e contato direto.",
  yearsLine: "{{n}}+ anos em SAP",
  modulesLabel: "Módulos SAP",
  industriesLabel: "Setores",
  raul: {
    name: "Raul Garcia Bonifaz",
    role: "Diretor de programas SAP e desenvolvimento de negócios",
    bio: "{{n}}+ anos liderando implementações SAP e desenvolvimento de negócios no México e na América Latina. Antes, senior manager na KPMG e na IBM, à frente de grandes equipes SAP em programas para Heineken México, British American Tobacco e Banco Ficohsa.",
    industries: "Manufatura · Bebidas · Bancos · Farma · Varejo",
  },
  efren: {
    name: "Efrén Serrano",
    role: "Consultor sênior SAP de logística e cadeia de suprimentos",
    bio: "{{n}}+ anos em logística SAP e gestão avançada de armazéns. Delivery manager de implantações S/4HANA EWM em vários países. Na Accenture, entregou programas de cadeia de suprimentos para PepsiCo LATAM, Panasonic Automotive, KION Group e Convatec.",
    industries: "Automotivo · Farma · Dispositivos médicos · Manufatura · Bens de consumo",
  },
};
